import React from 'react';
import { Typography } from '@loophealth/loop-ui-web-library';
import { IOnboardingScreenStepItem } from './types';
import {
    OnboardingFtuxIllustrationOne,
    OnboardingFtuxIllustrationThree,
    OnboardingFtuxIllustrationTwo
} from '../../../assets/img';

export const OnboardingScreenFtuxSteps: IOnboardingScreenStepItem[] = [
    {
        title: (
            <Typography variant="titleXLarge" weight="semiBold">
                <Typography variant="titleXLarge" weight="semiBold" color="emerald">
                    Unlimited
                </Typography>
                &nbsp;healthcare from&nbsp;
                <Typography variant="titleXLarge" weight="semiBold" color="emerald">
                    top 10%
                </Typography>
                &nbsp;doctors
            </Typography>
        ),
        subtitle: 'Health benefits designed to keep you and your family out of the hospital.',
        nextButtonText: 'Next',
        showBadge: true,
        image: OnboardingFtuxIllustrationOne
    },
    {
        title: (
            <Typography variant="titleXLarge" weight="semiBold">
                <Typography variant="titleXLarge" weight="semiBold" color="emerald">
                    Claims experts
                </Typography>
                &nbsp;that work 24x7&nbsp;
                <Typography variant="titleXLarge" weight="semiBold" color="emerald">
                    to support
                </Typography>
                &nbsp;you
            </Typography>
        ),
        subtitle: 'From submission to settlement, we’re with you at every step.',
        nextButtonText: 'Next',
        image: OnboardingFtuxIllustrationTwo,
        backButton: true
    },
    {
        title: (
            <Typography variant="titleXLarge" weight="semiBold">
                <Typography variant="titleXLarge" weight="semiBold" color="emerald">
                    Easy registration
                </Typography>
                &nbsp;to start your family’s coverage
            </Typography>
        ),
        subtitle: 'Spend just a few minutes to enroll and unlock coverage and peace of mind.',
        nextButtonText: 'Get Started',
        image: OnboardingFtuxIllustrationThree,
        backButton: true
    }
];
